import { createBrowserRouter } from "react-router-dom";
import { Home } from "./Home/Home";
import InboxPage from "./InboxPage/InboxPage";
import { BACKEND_URL, OAUTH_URL } from "../helpers/variables";
import LineItems from "./LineItems/LineItems";

async function AuthUser(auth_id) {
  try {
    let res = await fetch(`${OAUTH_URL}/login?auth_id=${auth_id}`);
    let data = await res.json();
    if (!res.ok) {
      throw new Response(`Authentication failed, ${res.statusText}`, {
        status: res.status,
      });
    }
    return data;
  } catch (err) {
    throw new Response(`Authentication failed, ${err.message}`, {
      status: 500,
    });
  }
}

async function getResponse(responseID) {
  try {
    let res = await fetch(
      `${BACKEND_URL}/get_response?response_id=${responseID}`
    );
    let data = await res.json();
    return data;
  } catch (err) {
    throw new Response(`Error, ${err.message}`, {
      status: 500,
    });
  }
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/inbox",
    loader: async ({ request }) => {
      const url = new URL(request.url);
  
      const authID = url.searchParams.get("id");
      const client_url = url.searchParams.get("client_url");
      const corporation_id = url.searchParams.get("corporation_id");
      const nimbleAuthID = url.searchParams.get("nimbleAuthID");
      const dev_mode = url.searchParams.get("dev_mode");

      if (!client_url || !corporation_id) {
        throw new Response("Missing required parameters", { status: 400 });
      }

      // let payload = await AuthUser(authID);
      return {
        // ...payload,
        client_url,
        corporation_id,
        nimbleAuthID,
        dev_mode: Boolean(dev_mode),
      };
    },
    element: <InboxPage />,
  },
  {
    path: "/lineItems",
    loader: async ({ request }) => {
      const url = new URL(request.url);
      const authID = url.searchParams.get("id");
      const responseID = url.searchParams.get("responseID");

      if (!responseID) {
        throw new Response("Missing required parameters", { status: 400 });
      }

      let payload = await AuthUser(authID);
      let verified_bill = await getResponse(responseID);
      return {
        responseID,
        ...payload,
        ...verified_bill,
      };
    },
    element: <LineItems />,
  },
]);

export default router;
